import './styles.scss';

const MainScreen = ({ title, text, button, tag, image, onClick }) => {
  return (
    <div className='mainScreen'>
      <div className='mainScreenContent'>
        <span className='mainScreenTag'>{tag}</span>
        <span className='mainScreenTitle'>{title}</span>
        <span className='mainScreenText'>{text}</span>
        <span className='mainScreenButton' onClick={onClick}>
          {button}
        </span>
      </div>
      <span className='mainScreenImage'>
        <img src={image} />
      </span>
    </div>
  );
};

export default MainScreen;
